import TopBar from "../components/misc/TopBar";
import SideBar from "../components/misc/SideBar";

import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";

const ForumPageLayout: React.FC = () => {
    const [open, setOpen] = React.useState(true);
    const toggleDrawer = () => {
        setOpen(!open);
    };
    const drawerWidth: number = 200;

    return (
        <Box display={"flex"}>
            <CssBaseline />
            <TopBar toggleDrawer={toggleDrawer} drawerWidth={drawerWidth} open={open} />
            <SideBar toggleDrawer={toggleDrawer} drawerWidth={drawerWidth} open={open} />
            <Outlet />
        </Box>
    );
};

export default ForumPageLayout;
